import { useQuery } from "@tanstack/react-query";
import { fetchPaymentHistoryDetail } from "../api/fetchPaymentHistoryDetail";

export const usePaymentHistoryDetail = (companyId, filters, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["paymentHistoryDetail", companyId, filters],
    queryFn: () => fetchPaymentHistoryDetail(companyId, filters),
    enabled: !!companyId && enabled,
  });

  return {
    data: data || null,
    error,
    isLoading,
    refetch,
  };
};
